/*
设备完好率--电站详情-图表
 */
import React, { Component } from "react";
import Echarts from "echarts";
import { Spin } from "antd";
import moment from "moment";
import fetchHandler from "../../../fetch/fetchHandler";
import { twoMonthStation } from "../../../fetch/fetchApi";

class StubStationIntactDetail extends Component {
  constructor(props) {
    super(props);
    this.props = props;
    this.state = {
      stubData: [],
      showSpinning: false,
    };
    this.layout = [
      "inline", // 横向布局
      "vertical", // 弹窗布局
      "horizontal", // 纵向布局
    ];
  }

  // 秒转换
  handleSecord(value) {
    const day = Math.floor(value / (24 * 3600)); // Math.floor()向下取整
    const hour = Math.floor((value - day * 24 * 3600) / 3600);
    const minute = Math.floor((value - day * 24 * 3600 - hour * 3600) / 60);
    const second = value - day * 24 * 3600 - hour * 3600 - minute * 60;
    if (day > 0) {
      return `${day}天${hour}时${minute}分`;
    } else if (hour > 0) {
      return `${hour}时${minute}分`;
    } else if (minute > 0) {
      return `${minute}分`;
    } else {
      return `${second}秒`;
    }
  }

  /**
   * 页面加载完成后执行，设置参数，加载数据
   */
  componentDidMount() {
    this.setState(
      {
        stubGroupId: this.query.stubGroupId,
        showSpinning: true,
      },
      () => {
        this.queryStubOperationModeInfo();
      },
    );
  }

  /**
   * 页面加载前执行，获取新开页传递参数
   */
  componentWillMount() {
    this.query = {};

    if (window.LayoutTab && window.LayoutTab.tabParam) {
      this.query["stubGroupId"] = window.LayoutTab.tabParam.stubGroupId; // '58567ff2-ece9-44b7-94db-c396ce753fc7' //
    }
  }

  // 调用接口获取数据
  queryStubOperationModeInfo() {
    fetchHandler(twoMonthStation, {
      stubGroupId: this.state.stubGroupId,
    }).then((res) => {
      if (res) {
        // 设置图表数据，图表加载lodading关闭
        this.setState(
          {
            stubData: [...res.data],
            showSpinning: false,
          },
          () => {
            // 绘制图表方法
            this.stubIntactChart();
          },
        );
      }
    });
  }

  /**
   * 完好率按日期图表展示
   */
  stubIntactChart() {
    const arryData = [...this.state.stubData];

    /**
     * 设置X轴
     */
    const xAxisData = arryData.map((item) => {
      return moment(item.date).format("MM.DD");
    });

    /**
     * 设置完好率数据
     */
    const intactData = arryData.map((item) => {
      return item.intactRate;
    });

    /**
     * 设置离线率数据
     */
    const offlineData = arryData.map((item) => {
      return item.offlineRate;
    });

    /**
     * 设置故障率数据
     */
    const errorData = arryData.map((item) => {
      return item.errorRate;
    });

    /**
     * 设置可用率率数据
     */
    const availableData = arryData.map((item) => {
      return item.availableRate;
    });

    /**
     * 设置平均完好时长数据
     */
    const stubNumData1 = arryData.map((item) => {
      const foo = {
        value:
          item.stubCnt === 0
            ? 0
            : parseInt(item.totalOperationDuration / item.stubCnt)
              - parseInt(item.totalErrorDuration / item.stubCnt)
              - parseInt(item.totalOfflineDuration / item.stubCnt),
        info: {
          all:
            item.stubCnt === 0
              ? 0
              : parseInt(item.totalOperationDuration / item.stubCnt),
          value:
            item.stubCnt === 0
              ? 0
              : parseInt(
                parseInt(item.totalOperationDuration / item.stubCnt)
                    - parseInt(item.totalErrorDuration / item.stubCnt)
                    - parseInt(item.totalOfflineDuration / item.stubCnt),
              ),
        },
      };
      return foo;
    });

    /**
     * 设置平均故障时长数据
     */
    const stubNumData2 = arryData.map((item) => {
      const foo = {
        value:
          item.stubCnt === 0
            ? 0
            : parseInt(item.totalErrorDuration / item.stubCnt),
        info: {
          value:
            item.stubCnt === 0
              ? 0
              : parseInt(item.totalErrorDuration / item.stubCnt),
        },
      };
      return foo;
    });

    /**
     * 设置平均离线时长数据
     */
    const stubNumData3 = arryData.map((item) => {
      const foo = {
        value:
          item.stubCnt === 0
            ? 0
            : parseInt(item.totalOfflineDuration / item.stubCnt),
        info: {
          value:
            item.stubCnt === 0
              ? 0
              : parseInt(item.totalOfflineDuration / item.stubCnt),
        },
      };
      return foo;
    });

    /**
     * 设置平均维护时长数据
     */
    const stubNumData4 = arryData.map((item) => {
      const foo = {
        value:
          item.availableCnt === 0
            ? 0
            : parseInt(
              (item.totalAvailableDuration - item.totalOfflineDuration)
                  / item.availableCnt,
            ),
        info: {
          value:
            item.availableCnt === 0
              ? 0
              : parseInt(item.totalAvailableDuration / item.availableCnt),
        },
      };
      return foo;
    });

    const myChart = Echarts.init(
      document.getElementById(`chart${this.state.chartId}`),
    );
    const option = {
      color: [
        "#e5323e",
        "#0000CD",
        "#6B8E23",
        "#FFD700",
        "#73D13D",
        "#FFBE56",
        "#729399",
        "#C0C0C0",
      ],
      tooltip: {
        trigger: "axis",
        axisPointer: {
          type: "cross",
          crossStyle: {
            color: "#999",
          },
        },
        formatter: (param) => {
          let result = `<div>平均运营时长:${this.handleSecord(
            param[4].data.info.all,
          )}，平均维护时长:${this.handleSecord(param[7].data.value)}</div>`;
          result += `<div>平均完好时长:${this.handleSecord(
            param[4].data.info.value,
          )},完好率:${param[0].data}%</div>`;
          result += `<div>平均可用时长:${this.handleSecord(
            param[7].data.info.value,
          )},可用率:${param[3].data}%</div>`;
          result += `<div>平均故障时长:${this.handleSecord(
            param[5].data.info.value,
          )},故障率:${param[2].data}%</div>`;
          result += `<div>平均离线时长:${this.handleSecord(
            param[6].data.info.value,
          )},离线率:${param[1].data}%</div>`;
          return result;
        },
      },
      legend: {
        data: [
          "完好率",
          "离线率",
          "故障率",
          "可用率",
          "平均完好时长",
          "平均故障时长",
          "平均离线时长",
          "平均维护时长",
        ],
      },
      grid: {
        left: "50px",
        right: "70px",
      },
      dataZoom: {
        // type: 'inside',
        showDetail: false,
        startValue: 0,
        endValue: 29,
        // maxValueSpan:11,
        handleIcon:
          "M10.7,11.9v-1.3H9.3v1.3c-4.9,0.3-8.8,4.4-8.8,9.4c0,5,3.9,9.1,8.8,9.4v1.3h1.3v-1.3c4.9-0.3,8.8-4.4,8.8-9.4C19.5,16.3,15.6,12.2,10.7,11.9z M13.3,24.4H6.7V23h6.6V24.4z M13.3,19.6H6.7v-1.4h6.6V19.6z",
        handleSize: "40%",
        handleStyle: {
          color: "#fff",
          shadowBlur: 3,
          shadowColor: "rgba(0, 0, 0, 0.6)",
          shadowOffsetX: 2,
          shadowOffsetY: 2,
        },
      },
      xAxis: [
        {
          type: "category",
          data: xAxisData,
          // name: '日期',
          // x轴文字倾斜
          axisLabel: {
            interval: 0,
            margin: 10,
            rotate: 35,
            textStyle: {
              fontWeight: "bolder",
              color: "#000000",
            },
          },
        },
      ],
      yAxis: [
        {
          type: "value",
          name: "",
          min: 0,
          max: 100,
          interval: 10,
          axisLabel: {
            formatter: "{value} %",
          },
        },
        {
          type: "value",
          show: false,
          name: "",
          // interval:Math.ceil(86400 / 10),
          min: 0,
          // max:86400,
          axisLabel: {
            formatter: "{value}",
            color: "#fff",
          },
        },
      ],
      series: [
        {
          name: "完好率",
          type: "line",
          yAxisIndex: 0,
          z: 4,
          data: intactData,
        },
        {
          name: "离线率",
          type: "line",
          yAxisIndex: 0,
          z: 4,
          data: offlineData,
        },
        {
          name: "故障率",
          type: "line",
          yAxisIndex: 0,
          z: 4,
          data: errorData,
        },
        {
          name: "可用率",
          type: "line",
          yAxisIndex: 0,
          z: 4,
          data: availableData,
        },
        {
          stack: "1",
          name: "平均完好时长",
          type: "bar",
          barWidth: 30,
          yAxisIndex: 1,
          barGap: "-100%",
          z: 3,
          data: stubNumData1,
        },
        {
          stack: "1",
          name: "平均故障时长",
          type: "bar",
          barWidth: 30,
          yAxisIndex: 1,
          barGap: "-100%",
          z: 2,
          data: stubNumData2,
        },
        {
          stack: "1",
          name: "平均离线时长",
          type: "bar",
          barWidth: 30,
          yAxisIndex: 1,
          barGap: "-100%",
          z: 1,
          data: stubNumData3,
        },
        {
          stack: "1",
          name: "平均维护时长",
          type: "bar",
          barWidth: 30,
          yAxisIndex: 1,
          barGap: "-100%",
          z: 1,
          data: stubNumData4,
        },
      ],
      contentToOption: function () {
        // 数据视图刷新的方法
        // this.stubIntactChart();
      },
    };
    myChart.clear();
    myChart.setOption(option);
    // 图例选中状态事件
    myChart.on("legendselectchanged", () => {});

    const daList = arryData.map((item) => {
      return moment(item.date).format("YYYY-MM-DD");
    });

    myChart.on("click", (obj) => {
      // 点击获取日期，调用父组件方法，更改表格传递参数
      this.props.changeDay(daList[obj.dataIndex]);
    });
  }

  render() {
    const Width = document.body.clientWidth - 245;
    return (
      <div className="analysis-content-3" id="stationIntackDeTAIL1">
        <Spin tip="加载中..." spinning={this.state.showSpinning}>
          <div
            style={{ width: Width, height: 400 }}
            id={`chart${this.state.chartId}`}
          >
          </div>
        </Spin>
      </div>
    );
  }
}

export default StubStationIntactDetail;



// WEBPACK FOOTER //
// ./src/AntD/pages/indicatorReport/stubIntactRate/stubStationIntactDetail.js